// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/user.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum wavin.aqora.v2.GlobalPermission
 */
export const GlobalPermission = proto3.makeEnum(
  "wavin.aqora.v2.GlobalPermission",
  [
    {no: 0, name: "GLOBAL_PERMISSION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "GLOBAL_PERMISSION_CREATE_SYSTEM", localName: "CREATE_SYSTEM"},
    {no: 2, name: "GLOBAL_PERMISSION_ADVICE", localName: "ADVICE"},
    {no: 3, name: "GLOBAL_PERMISSION_STATISTICS", localName: "STATISTICS"},
    {no: 5, name: "GLOBAL_PERMISSION_USER_ADMIN", localName: "USER_ADMIN"},
    {no: 4, name: "GLOBAL_PERMISSION_WAVIN_ONLY", localName: "WAVIN_ONLY"},
    {no: 6, name: "GLOBAL_PERMISSION_WAVIN_ONLY_ADMIN", localName: "WAVIN_ONLY_ADMIN"},
  ],
);

/**
 * A user with profile and permissions
 *
 * @generated from message wavin.aqora.v2.User
 */
export const User = proto3.makeMessageType(
  "wavin.aqora.v2.User",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "profile", kind: "message", T: Profile },
      {no: 4, name: "system_permissions", kind: "message", T: SystemPermission, repeated: true},
      {no: 5, name: "global_permissions", kind: "enum", T: proto3.getEnumType(GlobalPermission), repeated: true},
  ],
);

/**
 * @generated from message wavin.aqora.v2.Profile
 */
export const Profile = proto3.makeMessageType(
  "wavin.aqora.v2.Profile",
  () => [
    { no: 1, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "language_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email_notifications", kind: "enum", T: proto3.getEnumType(Profile_EmailNotifications) },
    { no: 4, name: "last_accepted_terms_and_conditions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Profile.EmailNotifications
 */
export const Profile_EmailNotifications = proto3.makeEnum(
  "wavin.aqora.v2.Profile.EmailNotifications",
  [
    {no: 0, name: "EMAIL_NOTIFICATIONS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EMAIL_NOTIFICATIONS_DISABLED", localName: "DISABLED"},
    {no: 2, name: "EMAIL_NOTIFICATIONS_ENABLED", localName: "ENABLED"},
    {no: 3, name: "EMAIL_NOTIFICATIONS_SHORT", localName: "SHORT"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.SystemPermission
 */
export const SystemPermission = proto3.makeMessageType(
  "wavin.aqora.v2.SystemPermission",
  () => [
    { no: 1, name: "system_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      {no: 2, name: "permissions", kind: "enum", T: proto3.getEnumType(SystemPermission_Permission), repeated: true},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.SystemPermission.Permission
 */
export const SystemPermission_Permission = proto3.makeEnum(
  "wavin.aqora.v2.SystemPermission.Permission",
  [
    {no: 0, name: "PERMISSION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PERMISSION_VIEWER", localName: "VIEWER"},
    {no: 2, name: "PERMISSION_CONTROL", localName: "CONTROL"},
    {no: 3, name: "PERMISSION_ADMIN", localName: "ADMIN"},
    {no: 5, name: "PERMISSION_COMMISSIONING", localName: "COMMISSIONING"},
    {no: 6, name: "PERMISSION_DESIGN", localName: "DESIGN"},
    {no: 7, name: "PERMISSION_USER_MANAGEMENT", localName: "USER_MANAGEMENT"},
  ],
);

